import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return <footer className="Footer"></footer>;
  }
}

export default Footer;
